module.exports = __webpack_public_path__ + "img/usa.420cadbb.svg";